export default __webpack_public_path__ + "static/media/t45-gun.b51f8eee.jpg";